import { render, staticRenderFns } from "./InformationIcon.vue?vue&type=template&id=c4b3bf08"
import script from "./InformationIcon.vue?vue&type=script&lang=js"
export * from "./InformationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports